var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.goodsSelDialogClose,
            visible: _vm.dialogVisible,
            title: "选择库存商品",
            "custom-class": "bairun-dialog bairun-dialog-small"
          }
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "15px", "text-align": "center" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "bairun-input-small",
                      staticStyle: { width: "60%", "text-align": "center" },
                      attrs: { placeholder: "商品名称或扫条码", clearable: "" },
                      on: {
                        input: function($event) {
                          return _vm.inputChange($event)
                        }
                      },
                      model: {
                        value: _vm.searchText,
                        callback: function($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.onSearch },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "bairun-dialog-table bairun-table-pager" },
            [
              _c(
                "el-table",
                {
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  },
                  on: { "selection-change": _vm.handleSelChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "ID", width: "40", type: "selection" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "库存", prop: "goodsStock" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类目", prop: "categoryName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "规格", prop: "goodsSpecification" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "单位", prop: "goodsUnit" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销售价", prop: "goodsPrice" }
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  layout: "total, prev, pager, next, jumper"
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.goodsSelDialogClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsSelDialogOk }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }